import { FC, useState } from "react";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import { Market } from "../../../domain/models/Market";
import useScreenSize from "../../../custom-hooks/useScreenSize";

interface MarketPopupProps {
    index: number;
    market: Market;
}

const MarketPopup: FC<MarketPopupProps> = (props) => {
    const { upTo800, moreOrEqual800 } = useScreenSize();
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            closingCrossClassName="mb-[15px] dmax2:mb-3 dmax2:w-[30px]"
            buttonElement={
                <div
                    onClick={() => setIsVisible(true)}
                    className="flex items-center justify-center w-[230px] dmax5:w-full h-[45px] border border-black hover:bg-black hover:text-white transition-all duration-300 rounded-[3px] pb-[2px] cursor-pointer dmin2:mr-[15px] di8:mr-1.5 dmax5:mt-6"
                >
                    {t("marketsSection.button")}
                </div>
            }
        >
            <div className="relative h-[90vh] max-h-[90vh] dmin2:w-[1140px] di8:w-[1080px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
                <div className="relative flex justify-between w-full h-full bg-white rounded-sm p-[50px] ti6:p-[30px] ti7:py-5 ti7:pl-5 ti7:pr-[15px] ti8:py-5 ti8:pl-5 ti8:pr-[15px] mi2:py-[15px] mi2:pl-[15px] mi2:pr-[8px] mi1:py-[15px] mi1:pl-[15px] mi1:pr-[8px] mi5:py-[15px] mi5:pl-[15px] mi5:pr-[8px]">
                    <div className="flex flex-col w-[382px] ti3:w-[315px] td8:w-[280px] mt5:w-full ti7:pr-[15px] ti8:pr-[15px] mi2:pr-[7px] mi1:pr-[7px] mi5:pr-[7px] overflow-y-auto scrollbar-popup h-full max-h-full">
                        {upTo800 && (
                            <div className="ti7:h-[280px] ti8:h-[230px] mi2:h-[230px] mi1:h-[230px] mi5:h-[230px] w-full mb-5">
                                <img
                                    src={`images/markets/market-${props.index}.jpg`}
                                    alt={`market-${props.index + 1}`}
                                    className="w-full min-h-full max-h-full object-cover rounded-[3px]"
                                />
                            </div>
                        )}
                        <p className="H32B dmax2:H24B">{props.market.name.toUpperCase()}</p>
                        <p className="H20B dmax2:H16B mt-2 dmax2:mt-1">{props.market.date}</p>
                        <p className="H16 text-[#848484] mt-3 dmax2:mt-2">{props.market.participantsNumber}</p>
                        <div className="flex flex-col mt-[30px]">
                            <p className="H16B">{t("marketsSection.address")}</p>
                            <p className="H16 dmax4:H14 mt-1.5">{props.market.address}</p>
                        </div>
                        <div className="flex flex-col mt-5 dmax2:mt-4">
                            <p className="H16B">{t("marketsSection.time")}</p>
                            <p className="H16 dmax2:H14 mt-1.5">{props.market.time}</p>
                        </div>
                        <div className="flex flex-col mt-5 dmax2:mt-4">
                            <p className="H16B">{t("marketsSection.participants")}</p>
                            <div className="flex flex-col">
                                {props.market.participants.map((participant, index) => (
                                    <>
                                        {participant.link ? (
                                            <a
                                                key={`participant-${index}`}
                                                href={participant.link}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="H16 dmax2:H14 mt-1.5"
                                            >
                                                <span className="underline">{participant.name}</span>
                                            </a>
                                        ) : (
                                            <div key={`participant-${index}`} className="H16 dmax2:H14 mt-1.5">
                                                {participant.name}
                                            </div>
                                        )}
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                    {moreOrEqual800 && (
                        <div className="h-full dmin2:w-[618px] di8:w-[560px] di7:w-[460px] ti3:w-[460px] td8:w-[400px]">
                            <img
                                src={`images/markets/market-${props.index}.jpg`}
                                alt={`market-${props.index + 1}`}
                                className="w-full h-full object-cover rounded-[3px]"
                            />
                        </div>
                    )}
                </div>
            </div>
        </CustomPopup>
    );
};

export default MarketPopup;
